import React from 'react';
import './index.less';
import countrySite from '@/common/country-site';
import Recommend from './recommend';
import PageStore from '@/stores/page';

export default function Index(props: {
  productId: string;
  companyId: string;
  i18n: DetailTypes.i18n;
  productCategoryId: string;
  abtest: DetailTypes.Abtest;
  renderConfig: DetailTypes.renderConfig<{
    strategy: string;
  }>;
}) {
  const { productId, companyId, renderConfig, productCategoryId } = props;
  const { strategy } = renderConfig;

  return (
    <Recommend
      strategy={strategy}
      companyId={companyId}
      productId={productId}
      categoryId={productCategoryId}
      country={countrySite() || ''}
    />
  );
}
